"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelDescription = void 0;
const exists_1 = __importDefault(require("../util/exists"));
const InvalidResult_1 = __importDefault(require("./InvalidResult"));
function modelDescription(_a) {
    var { properties, derivedProperties } = _a, otherDetails = __rest(_a, ["properties", "derivedProperties"]);
    return Object.assign({ userFacingTitle: 'object', userFacingValue: JSON.stringify, validate(value) {
            if (typeof value !== 'object' || value === null) {
                return new InvalidResult_1.default(`Not an object: ${value}`);
            }
            for (const key in properties) {
                const propertyDescription = properties[key];
                const propertyValue = value[key];
                if ((0, exists_1.default)(propertyValue)) {
                    const result = propertyDescription.validate(propertyValue);
                    if (result instanceof InvalidResult_1.default) {
                        return new InvalidResult_1.default(`Invalid property "${key}": ${result.reason}`);
                    }
                }
                else if (!propertyDescription.isOptional) {
                    return new InvalidResult_1.default(`Missing required property "${key}": ${propertyValue}`);
                }
            }
            return value;
        },
        properties,
        derivedProperties }, otherDetails);
}
exports.modelDescription = modelDescription;
